/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { useId, useState } from 'react';

import ContentDisclaimerText from './ContentDisclaimerText';

export default function ContentDisclaimerPopover({ handleDialog }: { handleDialog: () => void }) {
  const [expanded, setExpanded] = useState(false);
  const id = useId();
  const titleId = `${id}-title`;
  const summaryId = `${id}-summary`;
  const detailsId = `${id}-details`;

  return (
    <Dialog
      onClose={handleDialog}
      open={true}
      fullWidth
      maxWidth="sm"
      aria-labelledby={titleId}
      aria-describedby={summaryId}
      PaperProps={{
        sx: {
          backgroundColor: 'var(--white)',
          border: '2px solid var(--blue)',
          maxHeight: 'calc(100dvh - 32px)',
          margin: 2,
          width: 'calc(100% - 32px)',
        },
      }}
    >
      <DialogTitle id={titleId}>MedPearl Legal Disclaimer and Notice</DialogTitle>
      <DialogContent data-testid="legal-disclaimer-scroll" sx={{ minHeight: 0, overflowY: 'auto', fontSize: 14 }}>
        <Typography id={summaryId} variant="body2">
          Welcome to MedPearl! Our educational content is here to support your work, not replace your clinical judgment
          or individual patient assessment. Read the full notice below for details.
        </Typography>
        {!expanded && (
          <Button onClick={() => setExpanded(true)} aria-expanded={false} aria-controls={detailsId} sx={{ mt: 1 }}>
            Read full disclaimer
          </Button>
        )}
        <div id={detailsId} hidden={!expanded}>
          {expanded && <ContentDisclaimerText showTitle={false} />}
        </div>
      </DialogContent>
      <DialogActions sx={{ p: '12px 20px', borderTop: '1px solid var(--gray84)' }}>
        <Button variant="contained" onClick={handleDialog}>
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
}
